<div class="w-full flex flex-col gap-5">
  @for (item of data; track $index) {
    <!-- DEFAULT MODE -->
    @if (mode === 'default') {
      <div class="w-full" [ngClass]="showBorders ? 'border border-gray-200 dark:border-gray-700 rounded-md p-3' : ''">
        <div class="flex justify-between items-center mb-2" *ngIf="showItemHeader">
          <span class="text-xs font-bold text-gray-600 dark:text-gray-400">{{ item.label }}</span>
          <span class="text-xs font-bold text-gray-900 dark:text-white" [style.color]="item.color">{{ item.displayValue !== undefined ? item.displayValue : item.value + '%' }}</span>
        </div>
        <ng-container *ngIf="getNormalizedSegments(item).length; else singleValueProgress">
          <div
            class="rounded-full overflow-hidden flex w-full [--mat-progress-bar-track-color:theme(colors.gray.100)] dark:[--mat-progress-bar-track-color:theme(colors.gray.700)]"
            [ngClass]="heightClass"
          >
            @for (segment of getNormalizedSegments(item); track $index) {
              <div class="h-full transition-all duration-500 ease-out" [style.width.%]="segment.value" [style.background-color]="segment.color"></div>
            }
          </div>
        </ng-container>
        <ng-template #singleValueProgress>
          <mat-progress-bar
            mode="determinate"
            [value]="item.value"
            class="rounded-full overflow-hidden [--mat-progress-bar-track-color:theme(colors.gray.100)] dark:[--mat-progress-bar-track-color:theme(colors.gray.700)]"
            [ngClass]="heightClass"
            [style.--mat-progress-bar-track-height]="'100%'"
            [style.--mat-progress-bar-active-indicator-height]="'100%'"
            [style.--mat-progress-bar-active-indicator-color]="item.color">
          </mat-progress-bar>
        </ng-template>
      </div>
    }

    <!-- RICH MODE -->
    @if (mode === 'rich') {
      <div class="w-full bg-white dark:bg-surface-2 border border-slate-200 dark:border-gray-700/50 rounded-xl p-4 shadow-sm">
        <!-- Header: Icon & Title -->
        <div class="flex items-start gap-4 mb-4">
          @if (item.icon) {
            <div class="flex p-2.5 rounded-lg bg-slate-50 dark:bg-slate-700/50 text-slate-500 dark:text-slate-400">
               <app-icon-v2 [name]="item.icon" [size]="20"></app-icon-v2>
            </div>
          }
          <div class="flex-1">
            <div class="flex justify-between items-start">
              <div>
                <h3 class="text-sm font-semibold text-slate-800 dark:text-slate-200">{{ item.label }}</h3>
                @if (item.description) {
                  <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{{ item.description }}</p>
                }
              </div>
              <div class="text-right">
                 <span class="text-xs font-bold px-2 py-1 rounded-md bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300">
                    {{ item.value }}%
                 </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Stats Row -->
        <div class="flex items-end justify-between mb-3">
          <div class="flex items-baseline gap-2">
            <span class="text-xl font-bold text-slate-900 dark:text-white">{{ item.count | number }}</span>
            @if (item.growth) {
              <span class="text-xs font-medium flex items-center gap-0.5"
                [ngClass]="item.growthTrend === 'up' ? 'text-emerald-500' : 'text-rose-500'">
                {{ item.growth }}
                <!-- Simple arrow indicators -->
                @if (item.growthTrend === 'up') { <span>↗</span> }
                @if (item.growthTrend === 'down') { <span>↘</span> }
              </span>
            }
          </div>
          <span class="text-xs text-slate-400 dark:text-slate-500">Total Arrangements</span>
        </div>

        <!-- Progress Bar -->
        <div class="w-full rounded-full overflow-hidden" [ngClass]="[heightClass, trackColor]">
            <div class="h-full rounded-full transition-all duration-500 ease-out"
                 [style.width.%]="item.value"
                 [style.background-color]="item.color">
            </div>
        </div>
      </div>
    }
  }
</div>

